import gql from "graphql-tag"

export const QUERIES_MENU_ITEMS_QUERY = gql`
  query introspectionDocumentation {
    __type(name: "Query") {
      fields {
        name
      }
    }
  }
`
export const MUTATIONS_MENU_ITEMS_QUERY = gql`
  query introspectionDocumentation {
    __type(name: "Mutation") {
      fields {
        name
      }
    }
  }
`

export const INTROSPECTION_QUERY = gql`
  query introspectionDocumentation($type: String!) {
    __type(name: $type) {
      name
      kind
      description
      inputFields {
        name
        description
        defaultValue
        type {
          kind
          name
          description
          ofType {
            kind
            name
            description
            ofType {
              kind
              name
              description
            }
          }
        }
      }
      fields {
        name
        description
        type {
          kind
          name
          description
          ofType {
            kind
            name
            description
            ofType {
              kind
              name
              description
              ofType {
                kind
                name
                description
              }
            }
          }
        }
        args {
          name
          description
          type {
            name
            kind
            description
            ofType {
              kind
              name
              description
              ofType {
                kind
                name
                description
              }
            }
          }
        }
      }
    }
  }
`

export const TYPES_QUERY = gql`
  query introspectionDocumentation {
    __schema {
      types {
        kind
        name
        description
        inputFields {
          name
          description
          defaultValue
          type {
            kind
            name
            description
            ofType {
              kind
              name
              description
              ofType {
                kind
                name
                description
              }
            }
          }
        }
        fields {
          name
          description
          type {
            kind
            name
            description
            fields {
              name
              description
              isDeprecated
              deprecationReason
            }
            ofType {
              kind
              name
              description
              fields {
                name
                description
                isDeprecated
                deprecationReason
              }
              ofType {
                kind
                name
                description
                fields {
                  name
                  description
                  isDeprecated
                  deprecationReason
                }
              }
            }
          }
        }
      }
    }
  }
`
